import { ContextMenu, ContextMenuItem } from '@jusbrasil-web/shared-farol-context-menu'
import { ReactElement, RefObject } from 'react'

import { useMetrics } from '../../hooks'
import printStyles from '../../print.module.scss'

export type DocContextMenuProps = {
  dialogRef?: RefObject<HTMLDivElement>
  extraContextMenuItems?: ReactElement<typeof ContextMenuItem>[]
}

const metricsProperties = { from_component: 'docview/ContextMenu' }

export function DocContextMenu(props: DocContextMenuProps) {
  const { dialogRef, extraContextMenuItems } = props
  const { sendMetrics, ref: dispatcherRef } = useMetrics<HTMLDivElement>()

  return (
    <div className={printStyles.unprintable}>
      <ContextMenu
        ref={dispatcherRef}
        scope="body"
        dialogRef={dialogRef}
        onMetricsCallback={(eventName) => {
          sendMetrics(eventName, metricsProperties)
        }}
        extraContextMenuItems={extraContextMenuItems}
      />
    </div>
  )
}
